import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import PagePaper from '../../../components/Common/PagePaper';

const boxSx = {
  width: { xs: '100%', sm: 400 },
};
const emailBoxSx = {
  width: 'max-content',
  maxWidth: '100%',
  minWidth: { xs: 'inherit', sm: 400 },
};
const gridContainerSx = {
  position: 'relative',
};

export const FormPaperContainer = ({ children, testId, email, rescueDetails }) => (
  <Grid container data-testid={testId} sx={[rescueDetails && boxSx]}>
    <Grid item xs={12}>
      <Box sx={email ? emailBoxSx : boxSx}>
        <PagePaper>
          <Grid
            container
            direction="column"
            justifyContent="flex-start"
            alignItems="stretch"
            spacing={2}
            sx={gridContainerSx}
          >
            {children}
          </Grid>
        </PagePaper>
      </Box>
    </Grid>
  </Grid>
);

export const FormContainer = ({ children }) => (
  <Grid container>
    <Grid container direction="column" justifyContent="flex-start" alignItems="stretch" spacing={2}>
      {children}
    </Grid>
  </Grid>
);

export const GridRow = ({ children, hidden }) => {
  return !hidden ? (
    <Grid item>
      <Grid container direction="column" justifyContent="flex-start" alignItems="stretch">
        {children}
      </Grid>
    </Grid>
  ) : null;
};

export const RowTitle = ({ children }) => (
  <Grid item>
    <Typography variant="subtitle1" component="div">
      <Box fontWeight={600}>{children}</Box>
    </Typography>
  </Grid>
);

export const RowContent = ({ children }) => (
  <Grid item>
    <Typography variant="body1" component="div">
      {children}
    </Typography>
  </Grid>
);
